import axios from 'axios';
import AuthService from './auth.service';
const API_URL = process.env.REACT_APP_API_GATEWAY_URL;

class LambdaService {
  organisation(params = null) {
    delete axios.defaults.headers.common['access-token'];
    const axiosConfig = {
      headers: {
        'x-api-key':
          window.KEYS.REACT_APP_API_GATEWAY_KEY ||
          process.env.REACT_APP_API_GATEWAY_KEY,
        'Content-Type': 'application/json',
      },
      params,
    };
    return axios
      .get(API_URL + '/third-party/organisation', axiosConfig)
      .then((response) => {
        axios.defaults.headers.common[
          'access-token'
        ] = AuthService.getCurrentUser().accessToken;
        console.log('resp this', response.data);
        const options = response.data.data.map((i) => {
          let domain = i?.subdomain;
          let name = domain ? `${i.name} (${i.subdomain})` : `${i.name}`;
          return {
            name: name,
            id: i.grinds360Id,
          };
        });
        return options;
      });
  }
}

export default new LambdaService();
